module.exports = __webpack_public_path__ + "static/media/s_17.d4838c79.mp3";